import type {
  QualityIssueActions,
  QualityIssueCard,
  QualityUrls,
} from "@/lib/types"

import { CoverageGapCard } from "./CoverageGapCard"
import { DuplicateCard } from "./DuplicateCard"
import { IssueCard } from "./IssueCard"

interface Props {
  issues: QualityIssueCard[]
  urls: QualityUrls
  selectedIds: Set<number>
  onToggleSelect: (id: number) => void
}

// Dispatch per issue_type. Each card type is its own component so the V1
// surface stays explicit and reviewable.
export function Worklist({ issues, urls, selectedIds, onToggleSelect }: Props) {
  return (
    <div className="space-y-3" role="list" aria-label="Quality issues worklist">
      {issues.map((issue) => {
        const actions: QualityIssueActions | undefined =
          urls.issue_actions[String(issue.id)]
        if (!actions) {
          // Defensive — server should always include actions for every issue.
          return null
        }
        const selected = selectedIds.has(issue.id)
        const common = { issue, actions, selected, onToggleSelect }

        return (
          <div key={issue.id} role="listitem">
            {issue.issue_type === "coverage_gap" ? (
              <CoverageGapCard {...common} studioUrl={urls.studio} />
            ) : issue.issue_type === "duplicate" ? (
              <DuplicateCard {...common} />
            ) : (
              <IssueCard {...common} studioUrl={urls.studio} />
            )}
          </div>
        )
      })}
    </div>
  )
}
